<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M2,6C0.9,6,0,6.9,0,8C0,9.1,0.9,10,2,10C3.1,10,4,9.1,4,8C4,6.9,3.1,6,2,6C2,6,2,6,2,6ZM6,3C6,3,15,3,15,3C15.55,3,16,2.55,16,2C16,1.45,15.55,1,15,1C15,1,6,1,6,1C5.45,1,5,1.45,5,2C5,2.55,5.45,3,6,3C6,3,6,3,6,3ZM2,12C0.9,12,0,12.9,0,14C0,15.1,0.9,16,2,16C3.1,16,4,15.1,4,14C4,12.9,3.1,12,2,12C2,12,2,12,2,12ZM15,7C15,7,6,7,6,7C5.45,7,5,7.45,5,8C5,8.55,5.45,9,6,9C6,9,15,9,15,9C15.55,9,16,8.55,16,8C16,7.45,15.55,7,15,7C15,7,15,7,15,7ZM15,13C15,13,6,13,6,13C5.45,13,5,13.45,5,14C5,14.55,5.45,15,6,15C6,15,15,15,15,15C15.55,15,16,14.55,16,14C16,13.45,15.55,13,15,13C15,13,15,13,15,13ZM2,0C0.9,0,0,0.9,0,2C0,3.1,0.9,4,2,4C3.1,4,4,3.1,4,2C4,0.9,3.1,0,2,0C2,0,2,0,2,0Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'Properties',
} as DefineComponent
</script>
